import baseApi from "src/config/api/base"
import { ApplyRequest, ApplyResponse } from "./types/apply"
import { BaseResponse } from "./types/common"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"
import { GetConfigResponse } from "./types/config"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTokenByTckn1: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body,
          functionCode: "TTB0001",
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid: body.guid,
          TokenSessionId: body.TokenSessionId,
          functionCode: "TTB0001",
          NextTransactionUrl: "Facebook/TBBBilgiFormu/GetCaptcha1"
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    refreshCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid: body.guid,
          functionCode: "TTB0001",
          NextTransactionUrl: "Facebook/TBBBilgiFormu/RefreshCaptcha1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getConfig: builder.mutation<GetConfigResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          configKey: body,
          NextTransactionUrl: "Facebook/SMPUConfig/GetConfig1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply: builder.mutation<ApplyResponse, ApplyRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid: body.guid,
          nameSurname: body.nameSurname,
          phone: body.phone,
          captcha: body.captcha,
          channel: body.channel,
          kvkk: body.kvkk,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/TBBBilgiFormu/Apply1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    })
  })
})

export const { useGetTokenByTckn1Mutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useGetConfigMutation, useApplyMutation } = api

export default api
